import { FilterSubmitButton, useFilterFormError } from '@/components/common/Filter'
import { InputTypeahead } from '@/components/common/Input'
import { type FilterAdvancedCardPartialType, type FilterAdvancedCardType } from '@/defs/filters'

import styles from './FiltersPanelAdvancedFormCard.module.scss'

type Props = {
  filter: FilterAdvancedCardPartialType
  onSubmit: (filter: FilterAdvancedCardType) => void
  onUpdate: (filter: FilterAdvancedCardPartialType) => void
}

export const FiltersPanelAdvancedFormCard = ({ filter, onSubmit, onUpdate }: Props) => {
  const { card, slug } = filter
  const cardError = useFilterFormError(!card)

  const onSelect = (card: FilterAdvancedCardType['card']) => {
    onSubmit({ card, slug })
  }

  const onClear = () => {
    onUpdate({ card: undefined, slug })
  }

  return (
    <div className={styles.container}>
      <div className={styles.input}>
        <InputTypeahead
          aria-label='Search for a card'
          autoFocus
          borderColor={cardError.warn ? 'warning' : undefined}
          colorScheme='muted'
          icon='search'
          minCharacters={3}
          mode='card'
          onClear={onClear}
          onSelect={onSelect}
          placeholder='Search for a card...'
          value={card}
          wiggle={cardError.wiggle}
        />
      </div>
      <FilterSubmitButton />
    </div>
  )
}
